(() => {
  const desktopScrollQuery = window.matchMedia('(min-width: 990px)');
  let scrollRoot = null;
  let scrollFrame = 0;

  const getScrollRoot = () => {
    if (desktopScrollQuery.matches) {
      return document.querySelector('.page-wrapper') || document.scrollingElement || document.documentElement;
    }
    return document.scrollingElement || document.documentElement;
  };

  const updateHeader = () => {
    scrollFrame = 0;
    const header = document.querySelector('#header-component');
    if (!header) return;

    const scrollTop = scrollRoot ? scrollRoot.scrollTop : 0;
    const isCollapsed = header.dataset.frosthonHeaderCollapsed === 'true';
    if (!isCollapsed && scrollTop > 96) {
      header.dataset.frosthonHeaderCollapsed = 'true';
    } else if (isCollapsed && scrollTop <= 2) {
      delete header.dataset.frosthonHeaderCollapsed;
    }
  };

  const scheduleHeaderUpdate = () => {
    if (scrollFrame) return;
    scrollFrame = window.requestAnimationFrame(updateHeader);
  };

  const bindScrollRoot = () => {
    const nextRoot = getScrollRoot();
    if (nextRoot === scrollRoot) {
      scheduleHeaderUpdate();
      return;
    }
    if (scrollRoot) scrollRoot.removeEventListener('scroll', scheduleHeaderUpdate);
    scrollRoot = nextRoot;
    scrollRoot.addEventListener('scroll', scheduleHeaderUpdate, { passive: true });
    scheduleHeaderUpdate();
  };

  bindScrollRoot();
  window.addEventListener('resize', bindScrollRoot, { passive: true });
  desktopScrollQuery.addEventListener('change', bindScrollRoot);

  const measureDescription = (description) => {
    const content = description.querySelector('[data-frosthon-description-content]');
    const toggle = description.querySelector('[data-frosthon-description-toggle]');
    if (!content || !toggle) return;

    const style = window.getComputedStyle(content);
    const fontSize = Number.parseFloat(style.fontSize) || 14;
    const lineHeight = style.lineHeight === 'normal' ? fontSize * 1.6 : Number.parseFloat(style.lineHeight);
    const collapsedHeight = Math.ceil((lineHeight || fontSize * 1.6) * 4);
    const expanded = description.dataset.expanded === 'true';
    const fullHeight = content.scrollHeight;

    description.style.setProperty('--frosthon-description-collapsed-height', collapsedHeight + 'px');
    description.style.setProperty('--frosthon-description-expanded-height', fullHeight + 'px');

    const hasOverflow = fullHeight > collapsedHeight + 2;
    description.dataset.overflow = String(hasOverflow);
    if (!hasOverflow) {
      description.dataset.expanded = 'false';
      toggle.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      return;
    }

    toggle.hidden = false;
    description.dataset.expanded = String(expanded);
    toggle.setAttribute('aria-expanded', String(expanded));
    toggle.textContent = expanded ? toggle.dataset.lessLabel : toggle.dataset.moreLabel;
  };

  const initDescriptions = (scope) => {
    const roots = [];
    if (scope instanceof Element && scope.matches('[data-frosthon-description]')) roots.push(scope);
    if (scope.querySelectorAll) roots.push(...scope.querySelectorAll('[data-frosthon-description]'));

    roots.forEach((description) => {
      if (description.dataset.frosthonReady === 'true') return;
      const toggle = description.querySelector('[data-frosthon-description-toggle]');
      if (!toggle) return;
      description.dataset.frosthonReady = 'true';
      toggle.addEventListener('click', () => {
        const expanded = description.dataset.expanded !== 'true';
        description.dataset.expanded = String(expanded);
        toggle.setAttribute('aria-expanded', String(expanded));
        toggle.textContent = expanded ? toggle.dataset.lessLabel : toggle.dataset.moreLabel;
      });
      measureDescription(description);
    });
  };

  initDescriptions(document);
  window.addEventListener('resize', () => {
    document.querySelectorAll('[data-frosthon-description]').forEach(measureDescription);
  }, { passive: true });
  document.addEventListener('shopify:section:load', (event) => initDescriptions(event.target));
})();
